import { useSite } from "../../context/SiteContext";
import { waLink } from "../../lib/api";
import { WhatsAppIcon } from "./shared";

export default function FloatingWhatsApp() {
  const { content } = useSite();
  if (!content) return null;
  const c = content.contacts;

  return (
    <a
      data-testid="whatsapp-float-button"
      href={waLink(c.whatsapp_number, c.whatsapp_message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar com Frei Lucas no WhatsApp"
      className="fixed bottom-6 right-6 z-[90] group"
    >
      <span className="absolute inset-0 rounded-full bg-whatsapp animate-pulse-ring" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-whatsapp hover:bg-whatsappdark text-white shadow-2xl shadow-whatsapp/40 transition-all duration-300 group-hover:scale-110">
        <WhatsAppIcon className="w-7 h-7" />
      </span>
      <span className="hidden sm:block absolute right-full mr-4 top-1/2 -translate-y-1/2 whitespace-nowrap bg-olivedark text-cream text-xs font-medium px-4 py-2.5 rounded-xl opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 pointer-events-none">
        Fale com Padre Lucas agora
      </span>
    </a>
  );
}
